import { ToastId } from "@chakra-ui/react";
import { StepDetails, StepsAux } from "@constants";
import { useAuth, useCreateStep } from "@hooks";
import React from "react";

const DEFAULT_ERROR_HANDLER = (error: string) => {
  console.error(error);
};

const DEFAULT_STEP_DETAILS: StepDetails = {};

const DEFAULT_TOAST = () => 0 as ToastId;

export function useAddAuxStep(
  itemId: string,
  stepName: StepsAux,
  activateToast = DEFAULT_TOAST,
  setError = DEFAULT_ERROR_HANDLER,
) {
  const { user, logout } = useAuth();
  const { createStep } = useCreateStep();

  const addStepCallback = React.useCallback(
    async (comments: string, details = DEFAULT_STEP_DETAILS) => {
      setError("");
      try {
        const userId = user?.firebaseUser?.uid || "";
        const userName = user ? `${user.firstName} ${user.lastName}` : "";
        if (!userId || !userName) {
          console.error(
            "Missing auth information. The user will be logged out.",
          );
          await logout();
          return location.reload();
        }
        await createStep({
          moduleId: itemId,
          mainComponentSerial: itemId,
          userId,
          userName,
          stepName: stepName,
          timestamp: new Date(),
          comments,
          details: details,
        });
        activateToast();
      } catch (ex) {
        setError((ex as Error).message || "");
      }
    },
    [setError, user, logout, createStep, stepName, activateToast],
  );

  return addStepCallback;
}
